import { render } from "./experience.vue?vue&type=template&id=126cd5e6&scoped=true"
import script from "./experience.vue?vue&type=script&lang=js"
export * from "./experience.vue?vue&type=script&lang=js"

import "./experience.vue?vue&type=style&index=0&id=126cd5e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126cd5e6"]])

export default __exports__